import { __extends } from "tslib";
import { FormError, FormFieldValidator } from "Login/Decorator/Validator";
var BirthdateValidator = /** @class */ (function (_super) {
    __extends(BirthdateValidator, _super);
    function BirthdateValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BirthdateValidator.prototype.isValid = function (input) {
        var formError = new FormError();
        if (!(input.year && input.month && input.day))
            return formError;
        var strDate = "".concat(input.year, "-").concat(input.month, "-").concat(input.day);
        var date = new Date(strDate);
        formError.assert(date instanceof Date && !isNaN(date.getTime()), 'validation.birthdate.invalidFormat');
        if (formError.valid) {
            input.isValid = true;
            input.date = strDate;
        }
        return formError;
    };
    return BirthdateValidator;
}(FormFieldValidator));
export { BirthdateValidator };
